import { LegalEntityFinancialsFormValues } from 'features/new-actor/types/optim/legalEntityFinancialsFormValues';
import { ValidationRules } from 'helpers/createFormConfig';
import * as Yup from 'yup';

// An empty number input holds '': read it as "not filled" instead of a type error.
const emptyAsUndefined = (value: unknown, originalValue: unknown) =>
  originalValue === '' || originalValue === null ? undefined : value;

// Local calendar day "yyyy-MM-dd": the picker value is compared as a string, never through toISOString.
const today = (): string => {
  const now = new Date();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${mm}-${dd}`;
};

// Required when the subsidiaries block is enabled: the mappers turn a missing number into 0.
export const legalEntityFinancialsValidationRules: ValidationRules<keyof LegalEntityFinancialsFormValues> =
{
  revenue: Yup.number()
    .transform(emptyAsUndefined)
    .typeError('Le chiffre d\'affaires doit être un nombre')
    .required('Ce champ est requis')
    .min(0, 'Le chiffre d\'affaires ne peut pas être négatif'),

  employeesCount: Yup.number()
    .transform(emptyAsUndefined)
    .typeError('L\'effectif doit être un nombre')
    .required('Ce champ est requis')
    .integer('L\'effectif doit être un nombre entier')
    .min(0, 'L\'effectif ne peut pas être négatif'),

  fiscalYearEnd: Yup.string()
    .required('Ce champ est requis')
    .matches(/^\d{4}-\d{2}-\d{2}$/, { message: 'Date invalide', excludeEmptyString: true })
    .test(
      'not-in-future',
      'La date de clôture ne peut pas être dans le futur',
      (value) => !value || value <= today()
    ),
};
